import './App.css';
import { isMobile } from 'react-device-detect';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PrivacyPolicy from './page/privacy/PrivacyPolicy';
import SpaceCalendar from './page/calendar/SpaceCalendar';
import NewBody from './page/NewBody';
import WeeklyReport from './page/weeklyreport/WeeklyReport';
import MobileBottomNav from './components/navigationBar/MobileBottomNavBar';
import MobileContact from './page/company/MobileContact';
import { Login, Signup, MyPage, ChangeAccount } from './components/user';
import PricingPolicy from './page/pricingPolicy/PricingPolicy';
import PrivacyPolicyKr from './page/privacy/PrivacyPolicyKr';
import Astar from './page/astar/Astar';

function App() {

  const isKR = navigator.language === 'ko' || navigator.language === 'ko-KR';

  return (
    <>
      <BrowserRouter>
        {isMobile ? (
          <>
            <Routes>
              <Route path='/' element={<NewBody />} />
              <Route path='/spacecalendar/*' element={<SpaceCalendar />} />
              <Route path='/weeklyreport' element={<WeeklyReport />} />
              <Route
                path='/privacy-policy'
                element={isKR ? <PrivacyPolicyKr /> : <PrivacyPolicy />}
              />
              <Route path='/pricing-policy/*' element={<PricingPolicy />} />
              <Route path='/astar' element={<Astar />} />
              <Route path='/mobile-contact' element={<MobileContact />} />
              <Route path='/user/login' element={<Login />} />
              <Route path='/user/signup' element={<Signup />} />
              <Route path='/user/mypage' element={<MyPage />} />
              <Route path='/user/change-account' element={<ChangeAccount />} />
            </Routes>
            <MobileBottomNav />
          </>
        ) : (
          <>
            <Routes>
              <Route path='/' element={<NewBody />} />
              <Route path='/spacecalendar/*' element={<SpaceCalendar />} />
              <Route path='/weeklyreport' element={<WeeklyReport />} />
              <Route
                path='/privacy-policy'
                element={isKR ? <PrivacyPolicyKr /> : <PrivacyPolicy />}
              />
              <Route path='/pricing-policy/*' element={<PricingPolicy />} />
              <Route path='/astar' element={<Astar />} />
            </Routes>
          </>
        )}
      </BrowserRouter>
    </>
  );
}

export default App;
